import Swiper, { Autoplay, EffectFade } from 'swiper';

new Swiper('.announcement-bar__slider.swiper', {
  modules: [Autoplay, EffectFade],
  allowTouchMove: false,
  loop: true,
  autoplay: { delay: 5000, disableOnInteraction: false },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  effect: 'fade',
  fadeEffect: { crossFade: true },
});

